module.exports = __webpack_public_path__ + "santa-claus.c37d3198.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/xmas/santa-claus.png
// module id = 2598
// module chunks = 0